import { createContext, useContext, type ReactNode } from "react";
import type IFavoriteInteractions from "./favorite-interactions.interface";

const FavoriteInteractionsContext = createContext<IFavoriteInteractions | null>(
    null,
);

export function FavoriteInteractionsProvider({
    interactions,
    children,
}: {
    interactions: IFavoriteInteractions;
    children: ReactNode;
}) {
    return (
        <FavoriteInteractionsContext value={interactions}>
            {children}
        </FavoriteInteractionsContext>
    );
}

export function useFavoriteInteractions() {
    const interactions = useContext(FavoriteInteractionsContext);
    if (!interactions)
        throw new Error(
            "FavoriteInteractionsProvider is required for favorites",
        );
    return interactions;
}
